import { z } from 'zod';

export const StatementConfig = z.object({
  manualStatementGeneration: z.boolean(),
});
export type StatementConfig = z.infer<typeof StatementConfig>;
